module.exports={render:function (){
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-attr",
    class: ( _obj = {
      'rt-light': _vm.light
    }, _obj[("rt-attr-" + _vm.type)] = _vm.type, _obj[("rt-attr-label-" + _vm.labelPosition)] = _vm.labelPosition, _obj )
  }, [_vm._t("label", function() {
    var _obj;

    return [(_vm.label) ? _c('label', {
      staticClass: "rt-attr-label",
      class: ( _obj = {
        'label-bold': _vm.labelBold,
        'label-hidden': _vm.labelHidden
      }, _obj['label-' + _vm.labelAlign] = _vm.labelAlign, _obj ),
      style: ({
        color: _vm.labelColor,
        width: _vm.labelWidth
      })
    }, [(_vm.labelIconName) ? _c('rt-icon', {
      staticClass: "label-icon",
      attrs: {
        "name": _vm.labelIconName,
        "color": _vm.labelIconColor
      }
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "label-span",
      style: ({
        '-webkit-line-clamp': _vm.lineClamp
      })
    }, [_vm._v("\n        " + _vm._s(_vm.label) + "\n        "), (_vm.labelPosition === 'left') ? _vm._t("splitter", function() {
      return [_vm._v("\n          " + _vm._s(_vm.splitter || ' ') + "\n        ")]
    }) : _vm._e()], 2)], 1) : _vm._e()]
  }), _vm._v(" "), _vm._t("default", function() {
    var _obj;

    return [(_vm.visibleText) ? _c('span', {
      staticClass: "rt-attr-text",
      class: ( _obj = {
        'text-bold': _vm.textBold
      }, _obj['text-' + _vm.textAlign] = _vm.textAlign, _obj ),
      style: ({
        color: _vm.textColor
      })
    }, [(_vm.textIconName) ? _c('rt-icon', {
      staticClass: "text-icon",
      attrs: {
        "name": _vm.textIconName,
        "color": _vm.textIconColor
      }
    }) : _vm._e(), _vm._v(" "), _c('span', {
      ref: "text",
      staticClass: "text-span",
      class: {
        'text-link': _vm.$listeners && _vm.$listeners.click
      },
      style: ({
        '-webkit-line-clamp': _vm.lineClamp
      }),
      on: {
        "click": _vm.onTextClick
      }
    }, [_vm._v(_vm._s(_vm.text))])], 1) : _c('span', {
      staticClass: "rt-attr-text text-placeholder"
    }, [_vm._v(_vm._s(_vm.computedEmptyPlaceholder))])]
  }), _vm._v(" "), _vm._t("link", function() {
    return [(_vm.link) ? _c('div', {
      staticClass: "rt-attr-link"
    }, [_c('a', {
      on: {
        "click": _vm.link
      }
    }, [_vm._v(_vm._s(_vm.$tx('详情', 'xpc.business.attr.detail')))]), _vm._v(" "), _c('rt-icon', {
      attrs: {
        "name": "rt-base-arrow_right"
      }
    })], 1) : _vm._e()]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-477effd6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/business/common/rtAttr.vue
// module id = 2134
// module chunks = 137